import { Component, OnInit } from '@angular/core';
import { BaseService } from '../base.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(public _baseService: BaseService) { }

  ngOnInit() {
  }


  logout() {
    localStorage.clear();
    this._baseService.redirectTo('login');
  }

}
